if (!customElements.get('ly-main-product-form-custom-product-pergola-style-option-wrapper')) {
    customElements.define('ly-main-product-form-custom-product-pergola-style-option-wrapper', class extends HTMLElement {
        get activeStyle() {
            return this.querySelector('input[type="radio"]:checked').value
        }

        getOptionData = () => {
            return {
                key: this.dataset.title,
                values: [this.activeStyle]
            }
        }

        getData = () => {
            return {
                [this.dataset.title]: this.activeStyle
            }
        }
    })
}

if (!customElements.get('ly-main-product-form-custom-product-quantity-input')) {
    customElements.define('ly-main-product-form-custom-product-quantity-input', class extends HTMLElement {
        connectedCallback() {
            this.input = this.querySelector('input')
            this.buttons = this.querySelectorAll('button')

            this.input.addEventListener('change', this.inputChangeHandler)
            this.buttons.forEach(button => {
                button.addEventListener('click', this.buttonClickHandler)
            })
        }

        disconnectedCallback() {
            this.input.removeEventListener('change', this.inputChangeHandler)
            this.buttons.forEach(button => {
                button.removeEventListener('click', this.buttonClickHandler)
            })
        }

        inputChangeHandler = () => {
            if (+this.input.value < +this.input.min) {
                this.input.value = this.input.min
            }
        }

        buttonClickHandler = (evt) => {
            evt.preventDefault()
            evt.stopPropagation()
            switch (evt.currentTarget.name) {
                case 'minus':
                    this.input.stepDown()
                    break
                case 'plus':
                    this.input.stepUp()
                    break
            }
        }
    })
}

if (!customElements.get('ly-main-product-form-custom-product-accessory-option-wrapper')) {
    customElements.define('ly-main-product-form-custom-product-accessory-option-wrapper', class extends HTMLElement {

        connectedCallback() {
            this.accessoryOptions = [...this.querySelectorAll('ly-main-product-form-custom-product-accessory-option')]
        }

        getValues = () => {
            const values = []

            const checkedOptions = this.accessoryOptions.filter(option => option.checked)
            if (checkedOptions.length <= 0) return values

            checkedOptions.forEach(option => {
                values.push(option.getOptionData())
            })

            return values
        }

        getOptionData = () => {
            const result = {
                key: this.dataset.title,
                values: this.getValues()
            }

            return result
        }

        getData = () => {
            return {
                [this.dataset.title]: this.getValues().join(' | ')
            }
        }
    })
}

if (!customElements.get('ly-main-product-form-custom-product-accessory-option')) {
    customElements.define('ly-main-product-form-custom-product-accessory-option', class extends HTMLElement {
        connectedCallback() {
            this.checkbox = this.querySelector('input[type=checkbox]')
        }

        getOptionData = () => {
            let quantity = this.querySelector('input[type=number]').value

            let result = this.dataset.title

            quantity = Number(quantity)
            if (!isNaN(quantity) && quantity > 1) {
                result += ` x ${quantity}`
            }

            return result
        }

        get checked() {
            return this.checkbox.checked
        }
    })
}

if (!customElements.get('ly-main-product-form-custom-product-sidewall-option-wrapper')) {
    customElements.define('ly-main-product-form-custom-product-sidewall-option-wrapper', class extends HTMLElement {

        connectedCallback() {
            this.sidewallOptions = [...this.querySelectorAll('ly-main-product-form-custom-product-sidewall-option')]
        }

        getValues = () => {
            const values = []

            const checkedOptions = this.sidewallOptions.filter(option => option.checked)

            if (checkedOptions.length) {
                checkedOptions.forEach(option => {
                    values.push(option.getOptionData())
                })
            }

            return values
        }

        getOptionData = () => {
            const result = {
                key: this.dataset.title,
                values: this.getValues()
            }

            return result
        }

        getData = () => {
            return {
                [this.dataset.title]: this.getValues().map(item => {
                    return `${item.key}(${item.values.map(v => v.replaceAll('\n', '').replaceAll(' ', '')).join(', ')})`
                }).join(' | ')
            }
        }
    })
}

if (!customElements.get('ly-main-product-form-custom-product-sidewall-option')) {
    customElements.define('ly-main-product-form-custom-product-sidewall-option', class extends HTMLElement {

        connectedCallback() {
            this.checkbox = this.querySelector('input[type=checkbox]')
            this.wrappers = [...this.querySelectorAll('.ly-main-product-form-custom-product-sidewall-option-side-wrapper')]
            this.lengthWrapper = this.wrappers[0]
            this.widthWrapper = this.wrappers[1]

            this.lengthChangeUnsubscriber = window.subscribe('custom-product:length-change', this.lengthChangeHandler)
            this.widthChangeUnsubscriber = window.subscribe('custom-product:width-change', this.widthChangeHandler)
        }

        disconnectedCallback() {
            this.lengthChangeUnsubscriber()
            this.widthChangeUnsubscriber()
        }

        lengthChangeHandler = (data) => {
            this.lengthWrapper.querySelector('span').textContent = data
        }

        widthChangeHandler = (data) => {
            this.widthWrapper.querySelector('span').textContent = data
        }

        getOptionData = () => {
            const result = {
                key: this.dataset.title,
                values: []
            }

            this.wrappers.forEach(wrapper => {
                const key = wrapper.querySelector('.ly-main-product-form-custom-product-sidewall-option-side').textContent
                let quantity = wrapper.querySelector('input[type=number]').value

                let value = key.trim()

                quantity = Number(quantity)
                if (!isNaN(quantity) && quantity > 1) {
                    value += ` x ${quantity}`
                }

                result.values.push(value)
            })

            return result
        }

        get checked() {
            return this.checkbox.checked
        }
    })
}

if (!customElements.get('ly-main-product-form-custom-product-image-option-wrapper')) {
    customElements.define('ly-main-product-form-custom-product-image-option-wrapper', class extends HTMLElement {

        connectedCallback() {
            this.imgUploadWrapper = this.querySelector('.upload-wrapper')
            this.imgPreviewWrapper = this.querySelector('.preview-wrapper')
            this.fileInput = this.querySelector('input[type="file"]')

            this.fileInput.addEventListener('change', this.previewImage)
            this.imgPreviewWrapper.addEventListener('click', this.removeImage)
        }

        disconnectedCallback() {
            this.fileInput.removeEventListener('change', this.previewImage)
            this.imgPreviewWrapper.removeEventListener('click', this.removeImage)
        }

        previewImage = evt => {
            evt.preventDefault()
            evt.stopPropagation()

            const input = evt.target
            if (!input.files || input.files.length === 0) return

            const file = input.files[0]

            // 只处理图片
            if (!file.type.startsWith('image/')) {
                console.error('只能上传图片文件')
                input.value = ''
                return
            }

            this.updateUrl()

            // 生成 Blob URL
            const blobUrl = URL.createObjectURL(file)

            // 获取 img 元素并设置 src
            const img = this.imgPreviewWrapper.querySelector('img')
            if (img) {
                img.src = blobUrl
            }

            // 显示预览区
            this.imgPreviewWrapper.classList.remove('ly-hide')
            // 隐藏上传区
            this.imgUploadWrapper.classList.add('ly-hide')
        }

        removeImage = evt => {
            evt.preventDefault()
            evt.stopPropagation()

            // 清空 input
            this.fileInput.value = ''
            this._uploadPromise = null
            this._url = ''

            // 清空预览图
            const img = this.imgPreviewWrapper.querySelector('img')
            if (img) {
                img.src = ''
            }

            // 隐藏预览区，显示上传区
            this.imgPreviewWrapper.classList.add('ly-hide')
            this.imgUploadWrapper.classList.remove('ly-hide')
        }

        _uploadPromise = null
        _url = ''
        updateUrl = async () => {
            if (!(this.fileInput.files && this.fileInput.files.length > 0)) return

            if (!this._uploadPromise) {
                const file = this.fileInput.files[0]
                this._uploadPromise = API.uploadFiles(file)
            }

            const data = await this._uploadPromise
            this._url = data[0].url
        }

        getOptionData = async () => {
            const result = {
                key: this.fileInput.name,
                values: []
            }
            if (!(this.fileInput.files && this.fileInput.files.length > 0)) return result

            try {
                await this.updateUrl()
                result.values.push(this._url)
            } catch (err) {
                console.error(err)
            }

            return result
        }

        getData = async () => {
            const result = {}

            if (!(this.fileInput.files && this.fileInput.files.length > 0)) return result

            try {
                await this.updateUrl()
                result[this.dataset.title] = this._url
            } catch (err) {
                console.error(err)
            }

            return result
        }
    })
}

if (!customElements.get('ly-main-product-form-custom-product-upgrade-option-wrapper')) {
    customElements.define('ly-main-product-form-custom-product-upgrade-option-wrapper', class extends HTMLElement {
        connectedCallback() {
            this.inputs = [...this.querySelectorAll('input')]
        }

        getOptionData = () => {
            const result = {
                key: this.dataset.title,
                values: []
            }

            const checkedInputs = this.inputs.filter(input => input.checked)
            if (checkedInputs.length <= 0) return result

            checkedInputs.forEach(input => {
                result.values.push(input.name)
            })

            return result
        }
    })
}

if (!customElements.get('ly-main-product-form-custom-product-size-option-wrapper')) {
    customElements.define('ly-main-product-form-custom-product-size-option-wrapper', class extends HTMLElement {

        connectedCallback() {
            this.inputs = [...this.querySelectorAll('input')]
            this.lengthInput = this.inputs[0]
            this.widthInput = this.inputs[1]

            this.lengthChangeHandler()
            this.widthChangeHandler()

            this.lengthInput.addEventListener('change', this.lengthChangeHandler)
            this.widthInput.addEventListener('change', this.widthChangeHandler)
        }

        disconnectedCallback() {
            this.lengthInput.removeEventListener('change', this.lengthChangeHandler)
            this.widthInput.removeEventListener('change', this.widthChangeHandler)
        }

        lengthChangeHandler = () => {
            window.publish('custom-product:length-change', this.lengthInput.value)
        }

        widthChangeHandler = () => {
            window.publish('custom-product:width-change', this.widthInput.value)
        }

        verifyRequired = (input) => {
            input.classList.remove('is-dangerous')
            if (!input.value.trim()) {
                input.classList.add('is-dangerous')
                input.focus()
                throw new Error('Must fill in required fields')
            }
        }

        getValues = () => {
            const values = []
            this.inputs.forEach(input => {
                this.verifyRequired(input)

                const value = `${input.name}: ${input.value.trim()}`

                values.push(value)
            })

            return values
        }

        getOptionData = () => {
            const result = {
                key: this.dataset.title,
                values: this.getValues()
            }

            return result
        }

        getData = () => {
            return {
                [this.dataset.title]: this.getValues().join(' | ')
            }
        }
    })
}

if (!customElements.get('ly-main-product-form-custom-product')) {
    customElements.define('ly-main-product-form-custom-product', class extends HTMLElement {
        connectedCallback() {
            this.sizeWrapper = this.querySelector('ly-main-product-form-custom-product-size-option-wrapper')
            // this.upgradeWrapper = this.querySelector('ly-main-product-form-custom-product-upgrade-option-wrapper')
            this.imageWrapper = this.querySelector('ly-main-product-form-custom-product-image-option-wrapper')
            this.sidewallWrapper = this.querySelector('ly-main-product-form-custom-product-sidewall-option-wrapper')
            this.accessoryWrapper = this.querySelector('ly-main-product-form-custom-product-accessory-option-wrapper')
            this.pergolaStyleWrapper = this.querySelector('ly-main-product-form-custom-product-pergola-style-option-wrapper')
        }

        buildProperties = async () => {

            const result = [
                { ...this.pergolaStyleWrapper.getOptionData() },
                { ...this.sizeWrapper.getOptionData() },
                // { ...this.upgradeWrapper.getOptionData() },
                { ...this.sidewallWrapper.getOptionData() },
                { ...this.accessoryWrapper.getOptionData() },
                { ...(await this.imageWrapper.getOptionData()) }
            ]

            return result
        }

        buildPropertiesForRead = async () => {
            const result = {
                ...this.pergolaStyleWrapper.getData(),
                ...this.sizeWrapper.getData(),
                ...this.sidewallWrapper.getData(),
                ...this.accessoryWrapper.getData(),
                ...(await this.imageWrapper.getData())
            }

            return result
        }
    })
}